import React from 'react';
import { Link, NavLink, useMatch } from 'react-router-dom';

export default function Header() {
  const collectionIsActive = Boolean(useMatch('/work/:categorySlug'));
  return <header className="rg-header rg-editorial-header">
    <div className="rg-container rg-nav">
      <Link to="/" className="rg-brand">Resham Gurung<small>PHOTO RETOUCHING</small></Link>
      <nav aria-label="Main navigation">
        <NavLink end to="/">Home</NavLink>
        <NavLink to="/services">My expertise</NavLink>
        <Link to="/work/newborn" className={collectionIsActive ? 'active' : undefined} aria-current={collectionIsActive ? 'page' : undefined}>Collection</Link>
        <NavLink to="/about">About</NavLink>
        <NavLink to="/contacts">Contact</NavLink>
      </nav>
    </div>
  </header>;
}
